export default __webpack_public_path__ + "static/media/286.9f212596.gif";